import { DrawerLabel } from "./drawer-label";
import { FooterProps } from "./types";
import React from "react";
import {
  EdgeIcon,
  EdgeLogoIcon,
  SignOutIcon,
} from "../../../../../../shared/infrastructure";

export const Footer = ({ isOpen, logout }: FooterProps): React.ReactElement => (
  <section className="flex flex-col gap-[20px]">
    <section className="h-[1px] bg-white" />
    <div className="flex justify-center">
      <button onClick={logout} className="block">
        <DrawerLabel
          icon={SignOutIcon}
          isOpen={isOpen}
          isActive={false}
          title="Exit"
        />
      </button>
    </div>
    {isOpen ? (
      <EdgeIcon
        fill="white"
        width={85}
        height={40}
        style={{
          transition: "all ease 0.7s",
          transitionTimingFunction: "cubic-bezier(.4,0,.2,1)",
          margin: "0 auto",
          maxWidth: "80%",
        }}
      />
    ) : (
      <EdgeLogoIcon
        fill="white"
        width={45}
        height={45}
        style={{
          transition: "all ease 0.7s",
          transitionTimingFunction: "cubic-bezier(.4,0,.2,1)",
          margin: "0 auto",
        }}
      />
    )}
  </section>
);
